import { AsyncPipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';

import * as Highmaps from 'highcharts/highmaps';

import { ElementHostComponent } from '@components/element-widgets/element-host/element-host.component';
import { HighchartsDirective } from '@utils/charts/highcharts.directive';
import iconLibrary from 'src/app/common/iconLibrary';
import { ElementPipe } from 'src/app/element-handling/element.pipe';
import { ProvideElementsDirective } from 'src/app/element-handling/provide-elements.directive';
import { RouteSelectedFund } from '../selected-fund';
import { CountryChartOptionsPipe } from './country-chart-options.pipe';
import { TableToCountryPipe } from './table-to-country.pipe';

@Component({
  selector: 'wct-country-chart',
  standalone: true,
  imports: [
    ElementHostComponent,

    ProvideElementsDirective,
    HighchartsDirective,

    ElementPipe,
    AsyncPipe,
    TableToCountryPipe,
    CountryChartOptionsPipe,
  ],
  templateUrl: './country-chart.component.html',
  styleUrl: './country-chart.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CountryChartComponent {
  @Input({ required: true }) public documentId!: string;
  @Input({ required: true }) public reportIndex!: number;

  protected readonly Highmaps = Highmaps;
  protected readonly iconLibrary = iconLibrary;

  protected chart?: Highcharts.Chart;

  protected readonly funds = inject(RouteSelectedFund).refresh().get();

  protected async zoomIn(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.chart?.mapZoom(0.8);
  }

  protected async zoomOut(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.chart?.mapZoom(1.25);
  }
}
